import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import RotationMeter from './RotationKpiMeter';
import * as appDataActions from '../../../actions/appDataActions';
import * as trackingDataActions from '../../../actions/trackingDataActions';
import * as dataHelper from '../../../helpers/dataHelper';
import * as kpiConstants from '../../../constants/kpiConstants';
import * as kpiModels from '../../../models/kpiModels';
import * as keyboardConstants from '../../../constants/keyboardConstants';

class KpiOverviewBtn extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            kpi: this.props.kpi,
            activeKpi: this.props.activeKpi,
            className: "",

            guid: dataHelper.createGuid(),
            allowUpdates: true
        };

        this.getKpiMeterParams = this.getKpiMeterParams.bind(this);
        this.onComplete = this.onComplete.bind(this);
        this.setClass = this.setClass.bind(this);
        this.setProgressClass = this.setProgressClass.bind(this);
        this.onKpiBtnClicked = this.onKpiBtnClicked.bind(this);
        this.setKeyboardAccessibility = this.setKeyboardAccessibility.bind(this);
    }

    componentDidMount() {
        this.setClass();
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.activeKpi !== nextProps.activeKpi) {
            this.setState({
                activeKpi: nextProps.activeKpi,
                update: true
            });
        }
    }

    componentDidUpdate() {
        if (this.state.update) {
            this.setClass();
        }
    }


    getKpiMeterParams(is_primary) {
        //if (is_primary) {
            return kpiModels.PRIMARY_KPI_ROTATION_METER_PARAMS;
        /*} else {
            if(this.props.bite.kpis.length < 3){
                return kpiModels.PRIMARY_KPI_ROTATION_METER_PARAMS;
            }else{
                return kpiModels.DEFAULT_KPI_ROTATION_METER_PARAMS;
            }
        }*/
    }

    setClass() {
        let className = "";

        if(this.props.activeKpi.kpi_id === this.state.kpi.kpi_id ){
            className += " active";
        }

        return className;
    }

    setProgressClass(){
        let className = "";

        if(this.props.isComplete){
            className += " complete";
        }else{
            className += " incomplete";
        }

        return className;
    }

    onKpiBtnClicked() {

        if (this.state.activeKpi.kpi_id !== this.state.kpi.kpi_id) {
            this.props.onClickFunc(this.state.kpi);
        }
    }

    onComplete() {
        this.setState({allowUpdates: false});

    }

    setKeyboardAccessibility(event) {

        if (event.which === keyboardConstants.ENTER_KEY || event.which === keyboardConstants.SPACEBAR_KEY) {
            event.stopPropagation();
            event.preventDefault();
            this.onKpiBtnClicked();
        }
    }

    render() {
        return (
            <div className={`inline-item kpi-review-btn ${this.setClass()}`}
                key={`${this.state.kpi.kpi_id}_${dataHelper.createGuid()}`} onClick={this.onKpiBtnClicked} onKeyDown={this.setKeyboardAccessibility} role="link" tabIndex={0}>
                <div className={`progress-indicator ${this.setProgressClass()}`}/>
                <RotationMeter bite_id={this.props.bite_id}
                               kpiDefaults={this.state.kpi}
                               meterParams={this.getKpiMeterParams(this.state.kpi.is_primary)}
                               displayState={kpiConstants.KPI_DISPLAY_STATE_START}
                />
            </div>

        );
    }
}

KpiOverviewBtn.propTypes = {
    kpi: PropTypes.object.isRequired,
    bite_id: PropTypes.number.isRequired,
    activeKpi: PropTypes.object.isRequired,
    onClickFunc: PropTypes.func.isRequired,
    isComplete: PropTypes.bool
};

KpiOverviewBtn.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps() {
    return {};
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, trackingDataActions, appDataActions), dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(KpiOverviewBtn);



/** WEBPACK FOOTER **
 ** ./src/components/objects/kpi/KpiOverviewBtn.js
 **/